export default "__VITE_ASSET__CTny_hGV__"